import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { filterLoveFromCommunityCategories } from '../../../../../utils/community';
import { marketCategories } from '../../../../../utils/market';
import {
  familyLifeSubNav,
  foodAndShoopingSubNav,
  guidesSubNav,
} from '../../../../../utils/ronsTips';
import MuiDrawer from '../../../Common/MUIDrawer/MUIDrawer';
import MUIList from '../../../Common/MUIList/MUIList';
import { FOR_YOU_COMMUNITY_ROUTE, FOR_YOU_RONS_TIPS_ROUTE } from '../../../../../utils/routes';
import { checkIsAuthenticated } from '../../../../../utils/authUtils';

const MdKeyboardArrowLeft = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdKeyboardArrowLeft)
);

export default function BottomNavMenu({ open, onCloseHandler }) {
  const router = useRouter();
  const { city, tag_filter = 'most_popular' } = router?.query;
  const lang = useSelector(({ common }) => common?.language);
  const [isMainmenu, setIsMainmenu] = useState(true);
  const [isSubMenu, setIsSubMenu] = useState(false);
  const [isSecondarySubMenu, setIsSecondarySubMenu] = useState(false);
  const [subMenu, setSubMenu] = useState(null);
  const [secondarySubMenu, setSecondarySubMenu] = useState(null);
  const [cachedCategories, setCachedCategories] = useState([]);
  const categories = useSelector(({ community }) => {
    return community?.categories;
  });

  const ronTipsSubmenus = [
    {
      id: 'home',
      label: lang?.common?.home,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips?city=${city}`,
    },
    {
      id: 'guides',
      label: lang?.rons_tips?.guides,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/guides?city=${city}`,
    },
    {
      id: 'food_and_shopping',
      label: lang?.rons_tips?.food_and_shopping,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/food-shopping?city=${city}`,
    },
    {
      id: 'family_life',
      label: lang?.rons_tips?.familylife || 'Family Life',
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/family-life?city=${city}`,
    },
    {
      id: 'people',
      label: lang?.rons_tips?.people,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/people?city=${city}`,
    },
    {
      id: 'out_of_town',
      label: lang?.rons_tips?.out_of_town,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/out-of-town?city=${city}`,
    },
    {
      id: 'contests',
      label: lang?.rons_tips?.contest,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/contest?city=${city}`,
    },
    {
      id: 'market_events',
      label: lang?.market?.events,
      url: `/market/events?city=${city}&tag_filter=${tag_filter}`,
    },
    {
      id: 'newsletter_archive',
      label: lang?.rons_tips?.newsletter_archive,
      url: `${process.env.NEXT_PUBLIC_FRONTEND_URL}/rons-tips/newsletter-archive?city=${city}`,
    },
    checkIsAuthenticated() && {
      id: 'for_you',
      label: lang?.common?.for_you,
      url: FOR_YOU_RONS_TIPS_ROUTE(city),
    },
  ];

  const finalRonTipsSubMenus = ronTipsSubmenus?.map((item) => {
    return {
      label: item.label,
      onClickHandler: () => {
        if (item.id === 'guides') {
          const tempGuidesMenu = guidesSubNav(lang)?.map((item) => {
            return {
              label: item.name,
              onClickHandler: () => {
                router.push(item.url);
                // onCloseHandler()
              },
            };
          });
          setSecondarySubMenu(tempGuidesMenu);
          setIsSubMenu(false);
          setIsSecondarySubMenu(true);
        } else if (item.id === 'food_and_shopping') {
          const tempFoodAndShoppingMenu = foodAndShoopingSubNav(lang)?.map(
            (item) => {
              return {
                label: item.name,
                onClickHandler: () => {
                  router.push(item.url);
                  // onCloseHandler()
                },
              };
            }
          );
          setSecondarySubMenu(tempFoodAndShoppingMenu);
          setIsSubMenu(false);
          setIsSecondarySubMenu(true);
        } else if (item.id === 'family_life') {
          const tempFamilyLifeMenu = familyLifeSubNav(lang)?.map((item) => {
            return {
              label: item.name,
              onClickHandler: () => {
                router.push(item.url);
                // onCloseHandler()
              },
            };
          });
          setSecondarySubMenu(tempFamilyLifeMenu);
          setIsSubMenu(false);
          setIsSecondarySubMenu(true);
        } else {
          setIsSubMenu(false);
          router.push(item.url);
        }
      },
    };
  });

  useEffect(() => {
    if (categories === null) {
      setCachedCategories(JSON.parse(localStorage.getItem('categories')));
    }
  }, []);

  const list = [
    {
      label: lang?.common?.rons_tips,
      onClickHandler: () => {
        setSubMenu(finalRonTipsSubMenus);
        setIsMainmenu(false);
        setIsSubMenu(true);
      },
    },
    {
      label: lang?.common?.ron_community,
      onClickHandler: () => {
        // router.push(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/community?tag_filter=popular`)
        const tempCategories =
          filterLoveFromCommunityCategories(categories) ||
          filterLoveFromCommunityCategories(cachedCategories);
        setSubMenu([
          {
            label: 'Home',
            onClickHandler: () => {
              router.push(
                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/community?city=${city}&tag_filter=${tag_filter}`
              );
              onCloseHandler();
            },
          },
          ...tempCategories?.map((item) => {
            return {
              label: item.name === 'for_you' ? lang?.common?.for_you : item.name,
              onClickHandler: () => {
                if (item.name === 'for_you') {
                  router.push(FOR_YOU_COMMUNITY_ROUTE(city));
                } else {
                  router.push(
                    `${process.env.NEXT_PUBLIC_FRONTEND_URL}/community/categories/${item.id}`
                  );
                }
                onCloseHandler();
              },
            };
          }),
        ]);
        setIsMainmenu(false);
        setIsSubMenu(true);
      },
    },
    {
      label: lang?.common?.ron_market,
      onClickHandler: () => {
        // router.push(`${process.env.NEXT_PUBLIC_FRONTEND_URL}/market`)
        setSubMenu([
          {
            label: lang?.common?.home,
            onClickHandler: () => {
              router.push(
                `${process.env.NEXT_PUBLIC_FRONTEND_URL}/market?city=${city}&tag_filter=${tag_filter}`
              );
              onCloseHandler();
            },
          },
          ...marketCategories(lang, city).map((item) => {
            return {
              label: item.name,
              onClickHandler: () => {
                router.push(item.url);
                onCloseHandler();
              },
            };
          }),
        ]);
        setIsMainmenu(false);
        setIsSubMenu(true);
      },
    },
  ];

  return (
    <MuiDrawer open={open} onCloseHandler={onCloseHandler}>
      {(() => {
        if (isMainmenu) return <MUIList list={list} hasArrow={true} />;
        else if (isSubMenu)
          return (
            <div className='p-[16px]'>
              <div
                onClick={() => {
                  setIsMainmenu(true);
                }}
                className={` mb-[4px] flex cursor-pointer items-center font-semibold text-primary`}
              >
                <MdKeyboardArrowLeft className='  text-[24px] text-primary' />
                <span className='ml-3 text-[16px] font-semibold text-primary'>
                  {lang?.common?.back}
                </span>
              </div>
              <div className='bg-[#F9F9F9]'>
                <MUIList list={subMenu} />
              </div>
            </div>
          );
        else if (isSecondarySubMenu)
          return (
            <div className='p-[16px]'>
              <div
                onClick={() => {
                  setIsSecondarySubMenu(false);
                  setIsSubMenu(true);
                  setSubMenu(finalRonTipsSubMenus);
                }}
                className={` mb-[4px] flex cursor-pointer items-center font-semibold text-primary`}
              >
                <MdKeyboardArrowLeft className='text-[24px] ' />
                <span className='ml-3 text-[16px] font-semibold '>
                  {lang?.common?.back}
                </span>
              </div>
              <div className='bg-[#F9F9F9]'>
                <MUIList list={secondarySubMenu} />
              </div>
            </div>
          );
      })()}
    </MuiDrawer>
  );
}
